
import React from "react";
import { FaFilePdf, FaFileAlt, FaBullhorn, FaUsers, FaGraduationCap, FaClipboardList, } from "react-icons/fa";

const LatestUpdates = ({ onClose }) => {
    const publicUrl = process.env.PUBLIC_URL || "";

    const sections = [
        // {
        //     title: "General Notifications",
        //     theme: "general",
        //     icon: <FaBullhorn />,
        //     links: [
        //         {
        //             label: "General Notification",
        //             href: "/DSC2026/notifications/DSC-2026 General notification (1).pdf",
        //         },
        //     ],
        // },
        {
            title: "Notifications",
            theme: "societies",
            icon: <FaUsers />,
            links: [
                {
                    label: "General Notification",
                    href: "/DSC2026/notifications/DSC-2026 General notification (1).pdf",
                },
                {
                    label: "Societies Notification",
                    href: "/DSC2026/notifications/DSC-2026 Socities Notification.pdf",
                },
                {
                    label: "Special Education Notification",
                    href: "/DSC2026/notifications/DSC-2026 Special Education Notifcation.pdf",
                },
            ],
        },
        // {
        //     title: "Special Education",
        //     theme: "special",
        //     icon: <FaGraduationCap />,
        //     links: [
        //         {
        //             label: "Special Education Notification",
        //             href: "/DSC2026/notifications/DSC-2026 Special Education Notifcation.pdf",
        //         },

        //     ],
        // },
        {
            title: "Syllabus",
            theme: "dsc",
            icon: <FaFileAlt />,
            links: [
                {
                    label: "DSC-2026 Suggestive Syllabus",
                    href: "/DSC2026/DSC_2026 Suggestive Syllabus.pdf",
                },
                {
                    label: "Special Education Syllabus",
                    href: "/DSC2026/Special Education DSC - 2026.pdf",
                },
            ],
        },
        {
            title: "Government Orders",
            theme: "orders",
            icon: <FaClipboardList />,
            links: [
                {
                    label: "G.O.MS.No. 28",
                    href: "/DSC2026/Gos/2026SE_MS28_E.pdf",
                },
                {
                    label: "G.O.MS.No. 29",
                    href: "/DSC2026/Gos/2026SE_MS29_E.pdf",
                },
                {
                    label: "G.O.MS.No. 30",
                    href: "/DSC2026/Gos/2026SE_MS30_E.pdf",
                },
            ],
        },
        {
            title: "Press Note",
            theme: "press-note",
            icon: <FaFileAlt />,
            links: [
                {
                    label: "DSC-2026 Press Note",
                    href: "/DSC2026/DSC-2026 Press Note English.pdf",
                },
            ],
        },

    ];

    return (
        <div className="latest-updates-wrapper">
            <div className="latest-updates-header text-center">

                <h4>Important Notice </h4>

                <div className="latest-header-actions">
                    {onClose && (
                        <button type="button" className="latest-close-btn" onClick={onClose}
                            aria-label="Close latest updates" > &times; </button>
                    )}
                </div>
            </div>


            <div className="latest-updates-content">
                {/* <img
                    src={`${process.env.PUBLIC_URL || ""}/img/new2.gif`}
                    className="latest-new-gif"
                    alt="New updates"
                /> */}
                {sections.map((section) => (
                    <div className={`update-section ${section.theme}`} key={section.theme} >
                        <div className="update-section-icon">
                            {section.icon}
                        </div>

                        <div className="update-section-content">
                            <h5>{section.title}</h5>

                            <div className="update-links">
                                {section.links.map((link) => (
                                    <a href={`${publicUrl}${link.href}`} target="_blank"
                                        rel="noopener noreferrer"
                                        className="update-link"
                                        key={link.href}
                                    >
                                        <FaFilePdf className="pdf-icon" />
                                        <span>{link.label}</span>
                                        {/* <FaExternalLinkAlt className="external-icon" /> */}
                                    </a>
                                ))}
                            </div>
                        </div>
                        {/* <img src={`${publicUrl}/img/new2.gif`} className="latest-new-gif" alt="New updates" /> */}
                        {/* <span className="update-new-badge">NEW</span> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LatestUpdates;